import { ViewStream } from 'spyne';
import AIResponseTmpl from './templates/ai-response.tmpl.html';
import { UtilTraits} from 'traits/util-traits.js';

import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: false,        // IMPORTANT: do not allow raw HTML from models
  breaks: true,       // treat single line breaks as <br>
  linkify: false,     // no auto-linking
  typographer: false // no smart quotes
});

export default md;

export class AiResponsesView extends ViewStream {
  constructor(props = {}) {

    props.class = 'ai-response-view';

    function restoreLineBreaks(raw = '') {
      return raw.replace(/¶/g, '\n');
    }


    function normalizeMarkdown(text = '') {
      return text
        .replace(/\r\n/g, '\n') // Windows → Unix
        .replace(/\r/g, '\n') // old Mac
        .replace(/\\n/g, '\n'); // escaped newlines
    }

    function renderMarkdown(markdownText) {
      console.log("markdown text ",markdownText);

      const updatedText =  UtilTraits.util$normalizeMarkdown(markdownText);

      return md.render(updatedText || '');
    }


    const onResponse = (response)=>{

    }

    props.data.modelResponses = props.data.modelResponses.map(response => ({
      ...response,
      renderedHtml: renderMarkdown(response.responseMarkdown)
    }));


    props.template = AIResponseTmpl;
    super(props);
  }

  addActionListeners() {
    return [];
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {}
}
